export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          关于我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          51吃瓜最新网址的品牌故事
        </p>
        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70 max-w-[800px] mx-auto">
          <div className="flex flex-col gap-4">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              <strong className="text-primary-500 font-semibold">51吃瓜最新网址</strong>
              诞生于广大吃瓜群众对真实、快速、全面娱乐资讯的渴望。作为
              <strong className="text-foreground-900">吃瓜爆料第一站</strong>，
              我们致力于打造一个集51吃瓜爆料、51吃瓜黑料、51吃瓜今日黑料视频及爆料合集于一体的综合性内容平台。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              从51吃瓜爆料网到51吃瓜黑料网，我们不断完善内容生态，覆盖娱乐圈、网红圈及社会热点，每日更新海量51吃瓜最新爆料与黑料汇总。
              我们的编辑团队全天候追踪热点事件，坚持多方信息交叉验证，力求为每一位访客呈现最接近真相的事件全貌。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              无论你是资深吃瓜达人还是偶尔围观的吃瓜路人，51吃瓜最新网址都是你获取51吃瓜爆料合集、51吃瓜黑料视频的最佳选择。
              理性吃瓜，快乐生活——这是我们的理念，也是我们对每一位用户的美好祝愿。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}